export default __webpack_public_path__ + "static/media/member-portal.26691950.png";